// components/InvestorDynamicRouter.tsx
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import InvestorProfile from '../investorOverview';
import EditRiskProfile from '../investorOverview/EditRiskProfile';
import ViewProfile from '../investorOverview/viewProfile';
import MutualFund from '../investorOverview/mutualFund';
import DirectEquity from '../investorOverview/directEquity';
import PMS from '../investorOverview/pms';
import Bonds from '../investorOverview/bonds';
import Alternates from '../investorOverview/alternates';
import CategoryWiseActionItems from '../investorOverview/mutualFund/CategoryWiseActionItems';
import OrderDetails from '../investorOverview/mutualFund/orders/OrderDetails';
import CheckandVerifyOtp from '../investorOverview/mutualFund/systematicPlans/CheckandVerifyOtp';
import PauseSIP from '../investorOverview/mutualFund/systematicPlans/PauseSIP';
import ReasonForCancellation from '../investorOverview/mutualFund/systematicPlans/ReasonForCancellation';
import ExploreMutualFund from '../investorOverview/exploreMutualFund';
import SIPCalculator from '../investorOverview/exploreMutualFund/SIPCalculator';
import GoalCalculator from '../investorOverview/exploreMutualFund/GoalCalculator';
import SelectedCategorySchemes from '../investorOverview/exploreMutualFund/SelectedCategorySchemes';
import EcasDownloads from '../investorOverview/eCasDownloads';
import Transaction from '../investorOverview/transcation';
import IndividualFundDetails from '../investorOverview/fundDetails';
import Redeem from '../investorOverview/mutualFund/redeem';
import SwitchAndStp from '../investorOverview/mutualFund/switchAndStp';
import DownloadUploadXSIP from '../investorOverview/mutualFund/mandates/DownloadUploadXSIP';
import Swp from '../investorOverview/mutualFund/swp';

const DynamicInvestorRoutes: React.FC = () => {
    const { path: basePath } = useRouteMatch();

    const routerList = [
        {
            name: 'Investor Dashboard',
            path: "",
            component: InvestorProfile,
        },
        {
            name: "Edit Risk Profile",
            path: "edit-risk-profile",
            component: EditRiskProfile,
        },
        {
            name: 'Investor Profile',
            path: "view-profile",
            component: ViewProfile,
        },
        {
            name: 'Investor Mutual Funds',
            path: "mutual-fund",
            component: MutualFund,
        },
        {
            name: 'Investor Direct Equity',
            path: "direct-equity",
            component: DirectEquity,
        },
        {
            name: 'Investor PMS',
            path: 'pms',
            component: PMS,
        },
        {
            name: 'Investor Debt',
            path: 'debt',
            component: Bonds,
        },
        {
            name: 'Investor Alternates',
            path: 'alternates',
            component: Alternates,
        },
        {
            name: 'Category Wise Breakup',
            path: 'mutual-fund/category-wise-breakup',
            component: CategoryWiseActionItems
        },
        {
            name: 'Order Details',
            path: 'mutual-fund/:orderId/order-details',
            component: OrderDetails,
        },
        {
            name: 'OTP Screen',
            path: 'mutual-fund/:typeid/otp-screen',
            component: CheckandVerifyOtp,
        },
        {
            name: 'Pause SIP',
            path: 'mutual-fund/pause-sip',
            component: PauseSIP
        },
        {
            name: 'OTP Screen',
            path: 'mutual-fund/otp-screen',
            component: CheckandVerifyOtp,
        },
        {
            name: 'Reason for cancellation',
            path: 'mutual-fund/:typeid/reason-for-cancellation',
            component: ReasonForCancellation,
        },
        {
            name: 'Cancel OTP Screen',
            path: 'mutual-fund/:typeid/reason-for-cancellation/cancel-otp-screen',
            component: CheckandVerifyOtp,
        },
        {
            name: 'Explore Mutual Funds',
            path: 'mutual-fund/explore',
            component: ExploreMutualFund,
        },
        {
            name: 'SIP Calculator',
            path: 'mutual-fund/explore/sip-calculator',
            component: SIPCalculator
        },
        {
            name: 'Goal Calculator',
            path: 'mutual-fund/explore/goal-calculator',
            component: GoalCalculator
        },
        {
            name: 'Selected Category Funds',
            path: 'mutual-fund/explore/selected-category-funds',
            component: SelectedCategorySchemes,
        },
        {
            name: 'eCAS Reports',
            path: 'mutual-fund/ecas-reports',
            component: EcasDownloads,
        },
        {
            name: 'Cart To Transaction',
            path: 'mutual-fund/explore/investment-details',
            // component: InvestmentDetails,
            component: Transaction,
            // component: TestInvestment,
        },
        {
            name: 'Fund Details',
            path: 'mutual-fund/explore/selected-category-funds/investment-details',
            // component: InvestmentDetails,
            component: Transaction,
            // component: TestInvestment,
        },
        {
            name: 'Individual Fund Dashboard',
            path: 'mutual-fund/explore/selected-category-funds/:individualFundId',
            component: IndividualFundDetails,
        },
        {
            name: 'Individual Fund Details',
            path: 'mutual-fund/explore/selected-category-funds/:individualFundId/investment-details',
            // component: InvestmentDetails,
            component: Transaction,
        },
        {
            name: 'Individual Fund Box',
            path: 'mutual-fund/explore/:individualFundId',
            component: IndividualFundDetails,
        },
        {
            name: 'Individual Fund Box',
            path: 'mutual-fund/explore/:individualFundId/investment-details',
            component: Transaction,
        },
        {
            name: 'Invest More',
            path: 'mutual-fund/invest-more',
            // component: InvestmentDetails,
            component: Transaction,
        },
        {
            name: 'Reedem',
            path: 'mutual-fund/redeem',
            component: Redeem,
        },
        {
            name: 'Switch',
            path: 'mutual-fund/switch',
            component: SwitchAndStp,
        },
        {
            name: 'STP',
            path: 'mutual-fund/stp',
            component: SwitchAndStp,
        },
        {
            name: 'SWP',
            path: 'mutual-fund/swp',
            // component: SWP,
            component: Swp
        },
        {
            name: 'DownloadUploadXSIP',
            path: 'mutual-fund/download-upload-xsip',
            component: DownloadUploadXSIP,
        },
    ]
    return (
        <Switch>
            {routerList.map((item, index) => {
                return (
                    <Route
                        exact
                        key={index}
                        path={`${basePath}/${item.path}`}
                        component={item.component}
                    />
                )
            })}
        </Switch>
    );
};

export default DynamicInvestorRoutes;